import { lazy } from 'react';

import type { AppRouteConfig } from '@/App/AppRoutes/types';

const TokenValidPage = lazy(() =>
  import('@/components/pages/TokenValidPage').then(({ TokenValidPage }) => ({ default: TokenValidPage })),
);

export const TokenValidRoute: AppRouteConfig = {
  key: 'token-valid-page',
  path: '/token_valid/:locale?',
  component: TokenValidPage,
};
